import { RootState } from '..';

export const selectPlants = (state: RootState) => state.plants.plants;

export const selectPlantErrors = (state: RootState) => state.plants.errors;
